import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { ApiResponse } from 'dtos'
import { OhioTitleVehicleApplicationReadyToPrintDto } from 'dtos/ohioTitleVehicleApplicationReadyToPrintDto'
import { OhioTitleVehicleDto } from 'dtos/ohioTitleVehicleDto'
import { PaginationParameters } from 'parameters'
import { URIQuery } from 'utils'

export const getOhioTitleVehicles = (parameters: PaginationParameters, cancelToken?: CancelToken) =>
  apiClient
    .get<ApiResponse<OhioTitleVehicleDto[]>>('/api/ohio-titles/vehicles' + URIQuery(parameters), { cancelToken })
    .then(res => res.data)

export const saveOhioTitleApplicationPacket = (values: OhioTitleVehicleDto, cancelToken?: CancelToken) =>
  apiClient
    .put<ApiResponse<OhioTitleVehicleDto>>('/api/ohio-titles/ohio-title-application-packet', values, {
      cancelToken
    })
    .then(res => res.data)

// export const saveAndMarkApplicationPacketReadyToPrint = (values: OhioTitleVehicleDto, cancelToken?: CancelToken) =>
//   apiClient
//     .put<ApiResponse<OhioTitleVehicleDto>>('/api/ohio-titles/application-packet-ready-to-print', values, {
//       cancelToken
//     })
//     .then(res => res.data)

export const saveAndMarkApplicationPacketReadyToPrint = (values: OhioTitleVehicleDto, cancelToken?: CancelToken) => {
  const dto = {
    vehicleGuid: values.vehicleGuid,
    ohioTitleIsApplicationPacketReadyToPrint: true,
    ohioTitleApplicationPacketReadyToPrintDateTime: new Date().toISOString()
  }

  return apiClient
    .put<ApiResponse<OhioTitleVehicleApplicationReadyToPrintDto[]>>(
      '/api/ohio-titles/application-packet-ready-to-print?includeApplicationPacketsReadyForBuildABox=false',
      [dto],
      { cancelToken }
    )
    .then(res => res.data)
}

export const getApplicationReadyToPrint = (includeApplicationPacketsReadyForBuildABox: boolean, cancelToken?: CancelToken) =>
  apiClient
    .get<ApiResponse<OhioTitleVehicleApplicationReadyToPrintDto[]>>(
      `/api/ohio-titles/application-packet-ready-to-print?includeApplicationPacketsReadyForBuildABox=${includeApplicationPacketsReadyForBuildABox}`,
      {
        cancelToken
      }
    )
    .then(res => res.data)

export const putApplicationReadyToPrint = (
  values: OhioTitleVehicleApplicationReadyToPrintDto[],
  includeApplicationPacketsReadyForBuildABox: boolean,
  cancelToken?: CancelToken
) =>
  apiClient
    .put<ApiResponse<OhioTitleVehicleApplicationReadyToPrintDto[]>>(
      `/api/ohio-titles/application-packet-ready-to-print?includeApplicationPacketsReadyForBuildABox=${includeApplicationPacketsReadyForBuildABox}`,
      values,
      {
        cancelToken
      }
    )
    .then(res => res.data)

export const putApplicationPacketReadyForBuildABox = (
  values: OhioTitleVehicleApplicationReadyToPrintDto[],
  includeApplicationPacketsReadyForBuildABox: boolean,
  cancelToken?: CancelToken
) =>
  apiClient
    .put<ApiResponse<OhioTitleVehicleApplicationReadyToPrintDto[]>>(
      `/api/ohio-titles/application-packet-ready-for-build-a-box?includeApplicationPacketsReadyForBuildABox=${includeApplicationPacketsReadyForBuildABox}`,
      values,
      {
        cancelToken
      }
    )
    .then(res => res.data)

export const generateApplicationPacket = (values: OhioTitleVehicleApplicationReadyToPrintDto[], cancelToken?: CancelToken) =>
  apiClient.post('/api/ohio-titles/generate-application-packet', values, { cancelToken, responseType: 'blob' }).then(res => {
    const blob = new Blob([res.data], { type: (res.headers['content-type'] ?? undefined) as string | undefined })
    const objectURL = URL.createObjectURL(blob)
    window.open(objectURL, '_blank')
  })
